<template>
  <div class="about-container">
    <TheAboutHeader />
    <router-view />
  </div>
</template>

<script>
import TheAboutHeader from "@/components/TheAboutHeader.vue";

export default {
  components: {
    TheAboutHeader
  }
};
</script>

<style lang="scss" scoped>
.about-container {
  padding-bottom: 50px;
}
</style>
